import zhTW from './zh-TW'
import en from './en'

const messages = {
  'zh-TW': zhTW,
  'en': en
}

export default messages 